export function SidebarLoading() {
  return (
    <div className='flex flex-col flex-1'>
      <div className='w-full h-9 mt-8 bg-gray/20 rounded-lg' />

      <div className='flex flex-col mb-4 space-y-6 mt-20 animate-pulse'>
        <div className='w-full h-9 bg-gray/20 rounded-lg' />
        <div className='w-full h-9 bg-gray/20 rounded-lg' />
        <div className='w-full h-9 bg-gray/20 rounded-lg' />
        <div className='w-full h-9 bg-gray/20 rounded-lg' />
        <div className='w-full h-9 bg-gray/20 rounded-lg' />
        <div className='w-full h-9 bg-gray/20 rounded-lg' />
      </div>
    </div>
  );
}
